/**
 * SUPER simple Auto incrementing id getter
 *
 * todo: replace this with a better solution
 */
export default class Uid {
  constructor(start = 0) {
    this.uid = start
  }

  getId() {
    this.uid++
    return this.uid
  }
}
